<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_corporate_vendor.edit_title')"
           fixed-tabs>
    <template #content>
      <v-container class="edit-promotion-content" fluid v-if="vendor">
        <v-form v-model="isFormValid"
                ref="form">
          <v-input :rules="requiredRules"
                   hide-details="auto"
                   v-model="vendor.from_time">
            <v-container fluid class="flex-column">
              <legend class="v-label theme--light">{{ $t('admin_corporate_vendor.from_time') }}</legend>
              <DateTimePickerInput v-model="vendor.from_time"
                                   hide-details></DateTimePickerInput>
            </v-container>
          </v-input>
          <v-input :rules="requiredRules"
                   hide-details="auto"
                   v-model="vendor.to_time">
            <v-container fluid class="flex-column">
              <legend class="v-label theme--light">{{ $t('admin_corporate_vendor.to_time') }}</legend>
              <DateTimePickerInput v-model="vendor.to_time"
                                   hide-details></DateTimePickerInput>
            </v-container>
          </v-input>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_corporate_vendor.name_en')"
                            v-model="vendor.name_en"
                            clearable
                            :rules="requiredRules"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_corporate_vendor.name_zh')"
                            v-model="vendor.name_zh"
                            clearable
                            :rules="requiredRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-input hide-details="auto"
                       v-model="vendor.icon_en"
                       :rules="requiredRules">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_corporate_vendor.icon_en') }}</legend>
                  <PhotoPreviewInput v-model="vendor.icon_en"
                                     div-class="promotion-icon-input"
                                     file-name="promotion-icon"></PhotoPreviewInput>
                  <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG; RECOMMENDED SIZE: <b>335(W) X 335(H)</b></small>
                </v-container>
              </v-input>
            </v-col>
            <v-col>
              <v-input hide-details="auto"
                       v-model="vendor.icon_zh"
                       :rules="requiredRules">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_corporate_vendor.icon_zh') }}</legend>
                  <PhotoPreviewInput v-model="vendor.icon_zh"
                                     div-class="promotion-icon-input"
                                     file-name="promotion-icon"></PhotoPreviewInput>
                  <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG; RECOMMENDED SIZE: <b>335(W) X 335(H)</b></small>
                </v-container>
              </v-input>
            </v-col>
          </v-row>
          <v-text-field outlined
                        :label="$t('admin_corporate_vendor.url_en')"
                        v-model="vendor.url_en"
                        clearable
                        :rules="requiredRules"></v-text-field>
          <v-text-field outlined
                        :label="$t('admin_corporate_vendor.url_zh')"
                        v-model="vendor.url_zh"
                        clearable
                        :rules="requiredRules"></v-text-field>

          <v-checkbox v-model="vendor.popup_enabled"
                      :label="$t('admin_corporate_vendor.popup_enabled')"></v-checkbox>
          <v-row v-if="vendor.popup_enabled">
            <v-col cols="12">
              <v-input hide-details
                       v-model="vendor.content_en">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_corporate_vendor.content_en') }}</legend>
                  <TinyMceEditor v-model="vendor.content_en"></TinyMceEditor>
                </v-container>
              </v-input>
            </v-col>
            <v-col cols="12">
              <v-input hide-details
                       v-model="vendor.content_zh">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_corporate_vendor.content_zh') }}</legend>
                  <TinyMceEditor v-model="vendor.content_zh"></TinyMceEditor>
                </v-container>
              </v-input>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.form.validate() && save()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {computed, ref, watch} from "@vue/composition-api";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";
import DateTimePickerInput from "@/components/DateTimePickerInput";
import TinyMceEditor from "@/components/TinyMceEditor";
import _ from 'lodash';

export default {
  name: 'EditCorporateVendorModal',
  components: {TinyMceEditor, DateTimePickerInput, PhotoPreviewInput, BGModal},
  props: {
    shown: Boolean,
    corporateVendorId: String,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          getCorporateVendor();
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };
    const getCorporateVendor = function () {
      root.$callAPI('hkiarace/admin/corporate_vendor/', {id: props.corporateVendorId}, function (response) {
        vendor.value = response.body.vendor;
      });
    }

    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return 'api/static/' + f;
      }
    };

    // Info
    const vendor = ref(null);
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);
    const save = async function () {
      root.$callAPI('hkiarace/admin/corporate_vendor/edit/', {
        ...vendor.value,

        icon_en: vendor.value.icon_en instanceof File ? await root.$convertFileToBase64(vendor.value.icon_en) : vendor.value.icon_en,
        icon_zh: vendor.value.icon_zh instanceof File ? await root.$convertFileToBase64(vendor.value.icon_zh) : vendor.value.icon_zh,
      }, () => {
        root.$showAlertMessage('Info Saved');
        getCorporateVendor();
      })
    }

    return {
      dialogShown,

      cancel,

      getURL,

      // Info
      vendor,
      requiredRules,
      save,
    }
  }
}
</script>

<style lang="less">
.edit-promotion-content {
  display: flex;
  height: 100%;
  flex-direction: column;
}
</style>
